import actionTypes from '../constants/action-types';
import { DEFAULT_OPTIONS } from '../constants/default-options';

const addUserModifiedAttribute = (elementId, attribute, options = DEFAULT_OPTIONS) => ({
  type: actionTypes.ADD_USER_MODIFIED_ATTRIBUTE,
  payload: {
    elementId,
    attribute,
    options,
  },
});

export default addUserModifiedAttribute;
